<template>
  <layout-main-inner title="企业信息">
    <layout-card-wrap hasHeaderSlot
                      v-loading="loading">
      <template slot="title">基本信息</template>
      <el-button slot="form"
                 type="primary"
                 @click="edit"
                 v-if="userPermission.ENT_ADMIN"
                 :loading="loading">编辑</el-button>
      <el-form disabled
               label-position='top'>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="企业名称:">
              <span>{{vendorInfo.vendorName}}</span>
              <!-- <el-input v-model="vendorInfo.vendorName"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人:">
              <span>{{vendorInfo.vendorPerson}}</span>
              <!-- <el-input v-model="vendorInfo.vendorPerson"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人手机号:">
              <span>{{vendorInfo.vendorPhone}}</span>
              <!-- <el-input v-model="vendorInfo.vendorPhone"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="统一社会信用代码:">
              <span>{{vendorInfo.unifiedCreditCode}}</span>
              <!-- <el-input v-model="vendorInfo.unifiedCreditCode"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电子邮箱:">
              <span>{{vendorInfo.vendorEmail}}</span>
              <!-- <el-input v-model="vendorInfo.vendorEmail"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="贸易类型:">
              <span>{{vendorInfo.tradeTypes | tradeType}}</span>
              <!-- <el-checkbox-group v-model="vendorInfo.tradeTypes">
                <el-checkbox label="1">进出口</el-checkbox>
                <el-checkbox label="3">内销</el-checkbox>
              </el-checkbox-group> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="企业地址:">
              <span>{{vendorInfo.vendorAddress}}</span>
              <!-- <el-input v-model="vendorInfo.vendorAddress"></el-input> -->
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="企业账号:">
              <span>{{vendorInfo.adminAccount}}</span>

            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="所属机构:">
              <supervision-select :isEdit="false"
                                  v-model="vendorInfo.regulators" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="行业配置:">
              <industry-select :isEdit="false"
                               v-model="vendorInfo.categorys" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="标签类型:">
              <span>{{vendorInfo.tagTypes | tagType}}</span>
              <!-- <el-select v-model="vendorInfo.tagTypes"
                style="width: 100%"
                multiple
                placeholder="请选择">
                <el-option v-for="item in tags"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否套码:">
              <span>{{vendorInfo.tagModels |tagModel}}</span>
              <!-- <el-checkbox-group v-model="vendorInfo.tagModels">
                <el-checkbox label="1">普通码</el-checkbox>
                <el-checkbox label="2">套码</el-checkbox>
              </el-checkbox-group> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赋码方式:">
              <span>{{ vendorInfo.codingTypes | codingType}}</span>
              <!-- <el-checkbox-group v-model="vendorInfo.codingTypes">
                <el-checkbox label="1">建批赋码</el-checkbox>
                <el-checkbox label="2">出库赋码</el-checkbox>
              </el-checkbox-group> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出库对接:">
              <el-switch v-model="vendorInfo.outstockApi"
                         active-color="#13ce66"
                         inactive-color="#ff4949"
                         :active-value="1"
                         :inactive-value="0">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="营业执照:">
              <upload-image status="detail"
                            v-model="vendorInfo.businessLicenceFile"
                            :limit="1" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </layout-card-wrap>
    <layout-card-wrap hasHeaderSlot
                      style="margin-top: 15px"
                      v-loading="loading">
      <template slot="title">出库对接信息</template>
      <div slot="form"
           v-if="userPermission.ENT_ADMIN">
        <el-button type="primary"
                   @click="resetappkey"
                   :loading="loading">重置appKey</el-button>
        <el-button type="primary"
                   @click="editApp"
                   :loading="loading">编辑</el-button>
      </div>
      <el-form disabled
               label-position='top'>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="AppID:">
              <el-input v-model="appInfo.appId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="AppKey:">
              <el-input v-model="appInfo.appKey"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="ip地址:">
              <el-input v-model="appInfo.ip"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单完成通知地址:">
              <el-input style="width: auto;margin-right:5px"
                        v-model="appInfo.notifyOrderUrl"></el-input>
              <el-checkbox v-model="appInfo.notifyOrderFlag"
                           :true-label="1"
                           :false-label="0">接收通知</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出库单通知地址:">
              <el-input style="width: auto;margin-right:5px"
                        v-model="appInfo.notifyOutstockUrl"></el-input>
              <el-checkbox v-model="appInfo.notifyOutstockFlag"
                           :true-label="1"
                           :false-label="0">接收通知</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退货单通知地址:">
              <el-input style="width: auto;margin-right:5px"
                        v-model="appInfo.notifyGoodsReturnUrl"></el-input>
              <el-checkbox v-model="appInfo.notifyGoodsReturnFlag"
                           :true-label="1"
                           :false-label="0">接收通知</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </layout-card-wrap>
    <staff-table :callback="getapplyvendor" :staffProductDataScope="vendorInfo.staffProductDataScope" v-if="userPermission.ENT_ADMIN" />
    <!-- <staff-info /> -->
    <ent-register-modal :data="current"
                        ref="modal"
                        :fetch="getapplyvendor" />
    <ent-app-modal :data="currentApp"
                   ref="app"
                   :fetch="getappinfo" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import BaseData from '@/utils/baseData'
import SupervisionSelect from '../vendor/busi/supervision-select.vue'
import IndustrySelect from '../vendor/busi/industry-select.vue'
import UploadImage from '@/components/public/upload-image-new.vue'
import EntRegisterModal from './busi/ent-register-modal.vue'
import EntAppModal from './busi/ent-app-modal.vue'
import StaffTable from './busi/staff-table'
// import StaffInfo from './busi/staff-info'
import clonedeep from 'lodash.clonedeep'
export default {
  name: 'ent-detail',
  components: { SupervisionSelect, IndustrySelect, UploadImage, EntRegisterModal, EntAppModal, StaffTable },
  data () {
    return {
      loading: false,
      tags: BaseData.tags,
      vendorInfo: {
        menuNodes: []
      },
      appInfo: {},
      current: {},
      currentApp: {}
    }
  },
  watch: {},
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission
    })
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    getapplyvendor () {
      this.loading = true
      this.$store.dispatch(`vendor/getvendor`, {
        payload: {
          vendorId: this.$route.query.vendorId
        },
        success: (res) => {
          this.loading = false
          res.data.businessLicenceFile = res.data.businessLicenceFile ? res.data.businessLicenceFile.split(',').map(item => ({
            url: item,
            name: item
          })) : []
          res.data.tagModels = res.data.tagModels ? res.data.tagModels.split(',') : []
          res.data.tagTypes = res.data.tagTypes ? res.data.tagTypes.split(',').map(item => +item) : []
          res.data.codingTypes = res.data.codingTypes ? res.data.codingTypes.split(',') : []
          res.data.tradeTypes = res.data.tradeTypes ? res.data.tradeTypes.split(',') : []
          res.data.categorys = res.data.categorys || []
          res.data.regulators = res.data.regulators || []
          res.data.outstockApi = res.data.outstockApi || 0
          this.$set(this, 'vendorInfo', {
            ...this.vendorInfo,
            ...res.data
          })
          // this.vendorInfo = {
          //   ...this.vendorInfo,
          //   ...res.data
          // }
          if (res.data.outstockApi === 1) {
            this.getappinfo()
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getappinfo () {
      this.loading = true
      this.$store.dispatch(`vendor/getappinfo`, {
        payload: {
          vendorId: this.$route.query.vendorId
        },
        success: (res) => {
          this.loading = false
          this.appInfo = {
            ...this.appInfo,
            ...res.data
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    resetappkey () {
      this.$confirm('此操作将重置企业AppKey, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('vendor/resetappkey', {
            payload: {
              vendorId: this.$route.query.vendorId
            },
            success: res => {
              this.getappinfo()
              this.loading = false
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    edit () {
      let { vendorName, vendorPerson, vendorPhone, unifiedCreditCode, vendorEmail, vendorAddress, businessLicenceFile } = this.vendorInfo
      this.current = {
        vendorName,
        vendorPerson,
        vendorPhone,
        unifiedCreditCode,
        vendorEmail,
        vendorAddress,
        businessLicenceFile: clonedeep(businessLicenceFile)
      }
      this.$refs.modal.toggleModal(true)
    },
    editApp () {
      let { appId, appKey, ip, notifyOrderUrl, notifyOrderFlag, notifyOutstockUrl, notifyOutstockFlag, notifyGoodsReturnUrl, notifyGoodsReturnFlag } = this.appInfo
      this.currentApp = {
        appId, appKey, ip, notifyOrderUrl, notifyOrderFlag, notifyOutstockUrl, notifyOutstockFlag, notifyGoodsReturnUrl, notifyGoodsReturnFlag
      }
      this.$refs.app.toggleModal(true)
    }
  },
  mounted () {
    this.getapplyvendor()
  }
}
</script>
